export default __webpack_public_path__ + "static/media/who-is-that-pokemon.accfa4b5.webp";